import { DealStatus } from "../types/Deal";

// Statuses where a deal is live and accepting investment. The backend emits
// these granular values per investor access level.
export const LIVE_DEAL_STATUSES: DealStatus[] = [
  "LIVE_ALL",
  "LIVE_MEMBERS",
  "LIVE_PRIVATE",
];

const LIVE_STATUS_NAMES: readonly string[] = LIVE_DEAL_STATUSES;

export const isLiveDeal = (deal: { readonly status: string }): boolean =>
  LIVE_STATUS_NAMES.includes(deal.status);
